/**
 * Internal stage system
 *
 * Maps Vite mode to our internal stage enum
 *
 * Usage:
 *   const stage = useStage();
 *   if (stage === Stage.PROD) {
 *     // production code
 *   }
 */

export enum Stage {
  DEV = 'dev',
  STAGE = 'stage',
  PROD = 'prod',
}

export const useStage = (): Stage => {
  const mode = import.meta.env.MODE;
  switch (mode.toLowerCase()) {
    case 'development':
    case 'dev':
      return Stage.DEV;
    case 'staging':
    case 'stage':
      return Stage.STAGE;
    case 'production':
    case 'prod':
      return Stage.PROD;
    default:
      // Default to dev for unknown modes
      return Stage.DEV;
  }
};
